import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface FormItems {
  hjid: string;
  value: string;
  description: string;
  specId: Spec;
}
export interface Spec {
  hjid: string;
  value: string;
  type: string;
  formItems: FormItems[];
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    private appService: AppService
  ) {
    this.appData = appService.settings;
  }

  getFormItemSpec(): Observable<Spec[]> {
    const headers = new HttpHeaders().append('no-cache', 'true');
    return this.httpClient.get<Spec[]>(`${this.appData.webApi}/masterdata/getSimpleFormItemSpec`, {headers: headers})
  }
  getSpecById(specId: string): Observable<Spec>{
    return this.httpClient.get<Spec>(`${this.appData.webApi}/masterdata/getSimpleFormItemSpecById/${specId}`)
  }
  deleteSpec(specId: string){
    return this.httpClient.delete(`${this.appData.webApi}/masterdata/simpleFormItemSpec/${specId}`)
  }
  deleteFormItem(formItemId: string) {
    return this.httpClient.delete(`${this.appData.webApi}/masterdata/simpleFormItem/${formItemId}`);
  }
  updateSpec(spec: Spec){
    return this.httpClient.put(`${this.appData.webApi}/masterdata/simpleFormItemSpec/${spec.hjid}`,spec);
  }
  updateFormItem(formItem: FormItems) {
    return this.httpClient.put(`${this.appData.webApi}/masterdata/simpleFormItem/${formItem.hjid}`, formItem);
  }
  addSpec(spec: Spec){
    return this.httpClient.post(`${this.appData.webApi}/masterdata/simpleFormItemSpec`,spec)
  }
  addFormItem(formItem: FormItems) {
    return this.httpClient.post(`${this.appData.webApi}/masterdata/simpleFormItem`,formItem)
  }
}
